import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-mediazione-view',
  templateUrl: './form-mediazione-view.component.html',
  styleUrls: ['./form-mediazione-view.component.css']
})
export class FormMediazioneViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
